import React from "react";
import { Row, Col, Rate, Typography, Space } from "antd";
import "antd/dist/reset.css";

// 👉 Import WordPress image
import TrustSectionImg from "../../assets/images/TrustSectionImg.svg";

const { Text, Title } = Typography;

const ReviewItem = ({ name, rating, reviews }) => (
  <Space direction="vertical" align="center" size={6}>
    <Title level={5} style={{ margin: 0, fontWeight: 700 }}>
      {name}
    </Title>

    <Rate disabled allowHalf value={rating} style={{ color: "#00B67A" }} />

    <Text type="secondary" style={{ fontSize: 13 }}>
      Rating: <strong>{rating}</strong> / 5 | {reviews} reviews
    </Text>
  </Space>
);

const TrustSection = () => {
  return (
    <div
      style={{
        padding: "60px 20px",
        background: "#fff",
        textAlign: "center",
      }}
    >
      {/* WordPress Image (replaces text) */}
      <img
        src={TrustSectionImg}
        alt="Recommended by WordPress.org"
        style={{
          //height: 36,
          marginBottom: 32,
        }}
      />

      {/* Reviews */}
      <Row gutter={[48, 32]} justify="center">
        <Col>
          <ReviewItem name="Trustpilot" rating={4.6} reviews="30,466" />
        </Col>

        <Col>
          <ReviewItem name="Google" rating={4.8} reviews="1,237" />
        </Col>

        <Col>
          <ReviewItem name="hostadvice." rating={4.6} reviews="2,432" />
        </Col>

        <Col>
          <ReviewItem name="wpbeginner" rating={4.7} reviews="874" />
        </Col>
      </Row>
    </div>
  );
};

export default TrustSection;
